import { getFeaturesKeysObj } from 'utils/features/getFeaturesKeysObjects';

export async function getFeaturesKeysObjectsWebWorker(
  ...args: Parameters<typeof getFeaturesKeysObj>
): Promise<ReturnType<typeof getFeaturesKeysObj>> {
  const worker = new Worker(new URL('./worker.ts', import.meta.url));

  return new Promise<ReturnType<typeof getFeaturesKeysObj>>((resolve, reject) => {
    worker.onmessage = function (e: MessageEvent<ReturnType<typeof getFeaturesKeysObj>>) {
      resolve(e.data);
      worker.terminate();
    };

    worker.onerror = function (e: ErrorEvent) {
      reject(e);
      worker.terminate();
    };

    const [featuresKeys, context, stainIndexFilter] = args;
    worker.postMessage({ featuresKeys, context, stainIndexFilter });
  });
}
